function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_113",
  "data-name": "Group 113",
  transform: "translate(-508 -3711)"
}, React.createElement("path", {
  id: "Path_70",
  "data-name": "Path 70",
  d: "M522.615,3716.615l-3.209-3.208v2.406h-1.6V3711H517v11.231h.8v-4.813h1.6v2.406Z",
  transform: "translate(-1.78)"
}), React.createElement("path", {
  id: "Path_71",
  "data-name": "Path 71",
  d: "M512.813,3715.813h-1.6v-2.406L508,3716.615l3.209,3.209v-2.406h1.6v4.813h.8V3711h-.8Z",
  transform: "translate(0)"
}));

var SvgCompareNocolor = function SvgCompareNocolor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 12.835,
    height: 11.231,
    viewBox: "0 0 12.835 11.231",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCompareNocolor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/compare_nocolor.1c29002f.svg";
export { ForwardRef as ReactComponent };